import React from 'react'
import { ROLE_HEADER } from './constants'
import { inputModeType } from 'lib/util'
import {
  Header,
  RadioGroup,
  RadioRoleField,
  RoleDescriptionUnorderedList,
  RolesGroup,
  RoleLabel,
} from './component.styles'
import { RoleInfo, FormValues } from '../Form/types'

interface AddUserModalSelectRoleProps {
  inputMode: string
  rolesInfo: RoleInfo[]
  values: FormValues
}

const AddUserModalSelectRole: React.FC<AddUserModalSelectRoleProps> = ({
  inputMode,
  rolesInfo,
  values,
}) => {
  return (
    <RolesGroup aria-labelledby="my-radio-group" role="group">
      <Header id="my-radio-group">{ROLE_HEADER}</Header>
      {rolesInfo.map(roleInfo => {
        const isAdminRoleAndMultipleMode =
          inputMode === inputModeType.bulk && roleInfo.id === 'Admin'
        return (
          <RadioGroup key={roleInfo.id}>
            <RoleLabel disabled={isAdminRoleAndMultipleMode}>
              <RadioRoleField
                checked={values.selectedRole === roleInfo.id}
                disabled={isAdminRoleAndMultipleMode}
                name="selectedRole"
                type="radio"
                value={roleInfo.id}
              />
              {roleInfo.role}
            </RoleLabel>
            <RoleDescriptionUnorderedList
              isAdminRoleAndMultipleMode={isAdminRoleAndMultipleMode}
            >
              {roleInfo.description.map(description => (
                <li key={`${roleInfo.id}-${description}`}>{description}</li>
              ))}
            </RoleDescriptionUnorderedList>
          </RadioGroup>
        )
      })}
    </RolesGroup>
  )
}

export default AddUserModalSelectRole
